// extracted by mini-css-extract-plugin
export default {"form-group":"styles_form-group__BIkKl","form-label":"styles_form-label__E2-R2","form-input-container":"styles_form-input-container__uCwJg","form-input":"styles_form-input__mc0CD"};